import { i18nMark } from 'lingui-react';

const formattedMessages = {
  caseNumber: i18nMark('Case'),
  complaint: i18nMark('Complaint'),
  created: i18nMark('Created'),
  estimate: i18nMark('Estimate'),
  etr: i18nMark('ETR'),
  followup: i18nMark('Follow-Up'),
  notes: i18nMark('Notes'),
  serviceProvider: i18nMark('Service Provider'),
  severity: i18nMark('Severity'),
  status: i18nMark('Status'),
  unitNumber: i18nMark('Unit'),
  vinNumber: i18nMark('VIN'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./components/CasesPanel/messages.js